<template>
  <div data-v-f531b812="" :class="['app', 'app-ti_green', { 'turnover-mode': promoMode === 'turnover' }]">
    <div class="agent-header">
      <div class="header-top">
        <div class="back" @click="$router.back()">
          <i class="van-icon van-icon-arrow-left"></i>
        </div>
        <h1>{{ promoMode === 'turnover' ? $t('Turnover Rebate') : $t('Agent Center') }}</h1>
        <div class="header-right"></div>
      </div>
    </div>

    <div class="mode-loading" v-if="!promoMode">{{ $t('Loading') }}...</div>

    <turnover-agent-center
      v-else-if="promoMode === 'turnover'"
      :rebate-rate="rebateRate"
      :turnover-stats="turnoverStats"
    />

    <template v-else>
      <div class="mode-banner">
        <div class="mode-text">
        <strong>{{ $t('Current mode: Tier Rewards') }}</strong>
        <span>{{ $t('Tier agent tip') }}</span>
        </div>
        <button class="mode-btn" @click="$router.push('/shareMoney')">
          {{ $t('Go Share Earn Tier') }}
        </button>
      </div>

      <div class="agent-nav">
        <div
          v-for="item in navItems"
          :key="item.key"
          :class="['nav-item', { active: activeTab === item.key }]"
          @click="switchTab(item.key)"
        >
          {{ item.title }}
        </div>
      </div>

      <div class="agent-content">
        <agent-dashboard v-if="activeTab === 'home'" promo-mode="tier" :rebate-rate="0" />
        <agent-team v-if="activeTab === 'team'" promo-mode="tier" />
      </div>
    </template>
  </div>
</template>
<script>
import AgentDashboard from './agent/agentDashboard.vue';
import AgentTeam from './agent/agentTeam.vue';
import TurnoverAgentCenter from './agent/turnoverAgentCenter.vue';

export default {
  name: 'agentCenter',
  components: {
    AgentDashboard,
    AgentTeam,
    TurnoverAgentCenter
  },
  data() {
    return {
      activeTab: 'home',
      promoMode: '',
      rebateRate: 0,
      turnoverStats: {
        today: 0,
        total: 0,
        pending: 0
      }
    };
  },
  computed: {
    navItems() {
      // 阶梯模式只保留邀请奖励需要的代理首页和团队管理。
      return [
        { key: 'home', title: this.$t('Agent Home') },
        { key: 'team', title: this.$t('Team Management') }
      ];
    }
  },
  created() {
    this.loadPromoMode();
  },
  methods: {
    switchTab(key) {
      this.activeTab = key;
    },
    loadPromoMode() {
      const that = this;
      this.$apiFun.post('/api/tier-rewards', {}).then(res => {
        if (res.code === 200 && res.data) {
          that.promoMode = res.data.mode || 'tier';
          that.rebateRate = typeof res.data.rebateRate !== 'undefined' ? res.data.rebateRate : 0;
          that.turnoverStats = res.data.turnoverStats || that.turnoverStats;
        } else {
          that.promoMode = 'tier';
        }
      }).catch(() => {
        that.promoMode = 'tier';
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.app {
  min-height: 100vh;
  background: #f5f7fa;
}

.turnover-mode {
  background: #090b10;
}

.agent-header {
  background: linear-gradient(135deg, #3a7bd5, #00d2ff);
  background-image: url(/static/css/top_area_bg-w1ddLS2U.png);
  background-size: cover;
  background-position: center;
  color: #fff;
  position: relative;
  overflow: hidden;

  .header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 1;

    .back {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    h1 {
      flex: 1;
      text-align: center;
      font-size: 18px;
      margin: 0;
      font-weight: 600;
    }

    .header-right {
      width: 44px;
    }
  }
}

.mode-loading {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background: #f5f7fa;
}

.mode-banner {
  margin: 12px;
  padding: 12px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .mode-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;

    strong {
      font-size: 14px;
      color: #222;
    }

    span {
      font-size: 12px;
      color: #666;
      line-height: 1.4;
    }
  }

  .mode-btn {
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 4px;
    border: none;
    border-radius: 16px;
    padding: 6px 12px;
    font-size: 12px;
    background: linear-gradient(135deg, #3a7bd5, #00d2ff);
    color: #fff;
    cursor: pointer;

    &.ghost {
      background: #f0f4f8;
      color: #3a7bd5;
    }
  }
}

.agent-nav {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #eee;
  overflow-x: auto;

  .nav-item {
    flex: 1;
    min-width: 80px;
    text-align: center;
    padding: 12px 8px;
    font-size: 13px;
    color: #666;
    cursor: pointer;
    white-space: nowrap;

    &.active {
      color: #3a7bd5;
      font-weight: 600;
      border-bottom: 2px solid #3a7bd5;
    }
  }
}

.agent-content {
  min-height: 60vh;
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/components/agentCenter.vue